import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    duyet: { //object, optional // Thông tin duyệt
        duoc_duyet: null, //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: null, //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: null, //IdRef, optional // Mã người duyệt
    },
    loai_diem_den: null, //string, optional // Loại điểm đến
    thong_tin_chung: { //object, optional // Thông tin chung
        ten: null, //string, optional // Tên điểm đến an toàn
        anh: null, //IdRef, optional // Mã ảnh đại diện        
        giay_to: {}, //object, optional // Thông tin giấy tờ định danh điểm đến
        dia_chi: {}, //object, optional // Thông tin địa chỉ
        nguoi_dai_dien: {}, //object, optional // Thông tin người đại diện
    },
    du_lieu_khai_bao: {}, //object, optional // Dữ liệu khai báo khi đăng ký điểm đến an toàn
    nguoi_tao_id: null, //IdRef, optional // Mã người tạo
    thoi_diem_tao: null, //datetime, optional // Thời điểm tạo
};

// validation form
model.validForm = {
    duyet: { //object, optional // Thông tin duyệt
        duoc_duyet: [], //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: [], //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: [], //IdRef, optional // Mã người duyệt
    },
    loai_diem_den: [], //string, optional // Loại điểm đến
    thong_tin_chung: { //object, optional // Thông tin chung
        ten: [], //string, optional // Tên điểm đến an toàn
        anh: [], //IdRef, optional // Mã ảnh đại diện        
    },
    du_lieu_khai_bao: [], //object, optional // Dữ liệu khai báo khi đăng ký điểm đến an toàn
    nguoi_tao_id: [], //IdRef, optional // Mã người tạo
    thoi_diem_tao: [], //datetime, optional // Thời điểm tạo

};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    giay_to: { //object, optional // Thông tin giấy tờ định danh điểm đến
        so_giay_to: null, //string, optional // Mã số thuế/Mã số doanh nghiệp
        noi_cap: null, //string, optional // Nơi cấp
        ngay_cap: null, //datetime, optional // Ngày cấp
        scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
        dia_chi: null, //string, optional // Địa chỉ trên đăng ký kinh doanh
    },
    dia_chi: { //object, optional // Thông tin địa chỉ
        quoc_gia: null, //string, optional // Quốc gia
        quoc_tich_id: null, //IdRef, optional // Mã quốc tịch
        tinh: null, //string, optional // Tên tỉnh
        tinh_id: null, //IdRef, optional // Mã tỉnh
        huyen: null, //string, optional // Tên huyện
        huyen_id: null, //IdRef, optional // Mã huyện
        xa: null, //string, optional // Tên xa
        xa_id: null, //IdRef, optional // Mã xã
        dia_chi: null, //string, optional // Địa chỉ giao dịch
        kinh_do: null, //double, optional // Kinh độ
        vi_do: null, //double, optional // Vĩ độ
    },
    nguoi_dai_dien: { //object, optional // Thông tin người đại diện
        ho_ten: null, //string, optional // Họ và tên
        chuc_vu: null, //string, optional // Chức vụ
        ngay_sinh: null, //datetime, optional // Ngày sinh
        so_giay_to: null, //string, optional // Số CMT/ Căn cước/ Hộ chiếu
        gioi_tinh: null, //integer, optional // Giới tính
        dia_chi: null, //string, optional // Địa chỉ
        dien_thoai: null, //string, optional // Điện thoại
        email: null, //string, optional // Email
    },
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhGiayTo: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};

// validation các form khác
model.validFormOther = {
    giay_to: { //object, optional // Thông tin giấy tờ định danh điểm đến
        so_giay_to: [], //string, optional // Mã số thuế/Mã số doanh nghiệp
        noi_cap: [], //string, optional // Nơi cấp
        ngay_cap: [], //datetime, optional // Ngày cấp
        scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
        dia_chi: [], //string, optional // Địa chỉ trên đăng ký kinh doanh
    },
    dia_chi: { //object, optional // Thông tin địa chỉ
        quoc_gia: [], //string, optional // Quốc gia
        quoc_tich_id: [], //IdRef, optional // Mã quốc tịch
        tinh: [], //string, optional // Tên tỉnh
        tinh_id: [], //IdRef, optional // Mã tỉnh
        huyen: [], //string, optional // Tên huyện
        huyen_id: [], //IdRef, optional // Mã huyện
        xa: [], //string, optional // Tên xa
        xa_id: [], //IdRef, optional // Mã xã
        dia_chi: [], //string, optional // Địa chỉ giao dịch
        kinh_do: [], //double, optional // Kinh độ
        vi_do: [], //double, optional // Vĩ độ
    },
    nguoi_dai_dien: { //object, optional // Thông tin người đại diện
        ho_ten: [], //string, optional // Họ và tên
        chuc_vu: [], //string, optional // Chức vụ
        ngay_sinh: [], //datetime, optional // Ngày sinh
        so_giay_to: [], //string, optional // Số CMT/ Căn cước/ Hộ chiếu
        gioi_tinh: [], //integer, optional // Giới tính
        dia_chi: [], //string, optional // Địa chỉ
        dien_thoai: [], //string, optional // Điện thoại
        email: [], //string, optional // Email
    }
};

model.excelDiemDenAnToan = {
    formModel: {
        ho_ten: null,
        chuc_vu: null,
        user_so_giay_to: null,
        gioi_tinh: null,
        ngay_sinh: null,
        dia_chi_lien_lac: null,
        user_dien_thoai: null,
        ma_so_thue: null,
        email: null,
        user_ten: null,
        user_loai: null,
        ten_tinh: null,
        ten_huyen: null,
        ten_xa: null,
        user_dia_chi: null,
        giay_to_noi_cap: null,
        giay_to_ngay_cap: null,
        giay_to_dia_chi: null,
    },


    //Thay đổi thứ tự config với file excel bằng trường index, trường code phải sửa cả template, name không dùng tới
    configIndex:
        [
            {
                index: 0,
                code: "excel_stt",
                name: "STT"
            },
            {
                index: 1,
                code: "excel_ten_dd",
                name: "Tên điểm đến"
            },
            {
                index: 2,
                code: "excel_loai_dd",
                name: "Loại điểm đến"
            },
            {
                index: 3,
                code: "excel_sdt",
                name: "Số điện thoại"
            },
            {
                index: 4,
                code: "excel_tinh",
                name: "Tỉnh"
            },
            {
                index: 5,
                code: "excel_huyen",
                name: "Quận/Huyện"
            },
            {
                index: 6,
                code: "excel_xa",
                name: "Xã/Phường"
            },
            {
                index: 7,
                code: "excel_dia_chi",
                name: "Địa chỉ"
            },
            {
                index: 8,
                code: "excel_mst",
                name: "Mã số thuế"
            },
            {
                index: 9,
                code: "excel_ten_ndd",
                name: "Tên người đại diện"
            },
            {
                index: 10,
                code: "excel_chuc_vu_ndd",
                name: "Chức vụ"
            },
            {
                index: 11,
                code: "excel_so_giay_to",
                name: "Số CMT/Căn cước/Hộ chiếu"
            },
            {
                index: 12,
                code: "excel_ngay_sinh_ndd",
                name: "Ngày sinh"
            },
            {
                index: 13,
                code: "excel_thang_sinh_ndd",
                name: "Tháng sinh"
            },

            {
                index: 14,
                code: "excel_nam_sinh_ndd",
                name: "Năm sinh"
            },
            {
                index: 15,
                code: "excel_gt_ndd",
                name: "Giới tính"
            },
            
            {
                index: 16,
                code: "excel_email",
                name: "Email"
            },
            {
                index: 17,
                code: "excel_dia_chi_ndd",
                name: "Địa chỉ người đại diện"
            },           

        ]
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-thoi_diem_tao",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            'duyet.duoc_duyet': '',
            loai_diem_den: '',
            'thong_tin_chung.ten': '',
            'du_lieu_khai_bao.user_account': '',
            'thong_tin_chung.giay_to.so_giay_to': '',
            nguoi_tao_id: '',
            thoi_diem_tao: '',
            "thong_tin_chung.dia_chi.tinh_id": null, // optional Mã tỉnh
            "thong_tin_chung.dia_chi.huyen_id": null, // optional Mã huyện
            "thong_tin_chung.dia_chi.xa_id": null,
        },
        valid: {
            'duyet.duoc_duyet': [],
            loai_diem_den: [],
            'thong_tin_chung.ten': [],
            'du_lieu_khai_bao.user_account': [],
            nguoi_tao_id: [],
            thoi_diem_tao: [],
            thong_tin_chung: {
                dia_chi: {
                    "tinh_id": null, // optional Mã tỉnh
                    "huyen_id": null, // optional Mã huyện
                    "xa_id": null,
                }
            }
        },
        operator: {
            'thong_tin_chung.ten': ":regex_i:", //:regex:, $vn_text=Viêt nam
            'du_lieu_khai_bao.user_account': ":regex_i:",
            'thong_tin_chung.giay_to.so_giay_to': ":regex_i:",
            thoi_diem_tao: ":in_that_day:",
        }
    }
};

export default model;